// extracted by mini-css-extract-plugin
export var label = "_kf-2";
export var slideContainer = "_kf-0";
export var slider = "_kf-1";